import { format } from 'date-fns';
import React from 'react';
import { Table } from 'reactstrap';
import utils from '../../lib/utils';
const LoaSection = ({
  date,
  billingAddress,
  locations,
  companyField,
  proposalData,
  getBoxSumAmount,
  getLocationSumAmount,
}) => {
  return (
    <div className="loa-doc-page">
      <div className="no-break">
        <h2 className="loa-doc-main-title">Letter of Agency (LOA) Agreement</h2>
        <p className="loa-doc-date">
          Date: {utils.getDateTimeFormat(date ? date : new Date(), 'regular')}
        </p>
        <p>
          I, the above-signed customer, by signing the EPIK Proposal starting on page 1 of this
          documentation package, hereby designate and authorize EPIK or its agent to transfer my
          service(s) from my current chosen carrier(s) to EPIK. I also authorize EPIK or its agent
          to transfer my current telephone numbers, as listed below, used to provide service that
          EPIK may provide its service to me or to issue new numbers where existing numbers are not
          published. I authorize EPIK or its agent to obtain billing information, customer service
          records and other network information with regard to these numbers that may be required to
          provide me with EPIK service. I understand that I may consult with EPIK as to whether a
          fee will apply to the change. I understand that this LOA applies to all phone numbers and
          carriers listed below.
        </p>
        <Table bordered size="sm" className="legal-company-table">
          <tr>
            <td style={{ width: '25%' }} className="legal-company-table-header">
              Legal Company Name:
            </td>
            <td colSpan={5}>{companyField && companyField.companyName}</td>
          </tr>
          <tr>
            <td style={{ width: '25%' }} className="legal-company-table-header">
              DBA:
            </td>
            <td colSpan={5}></td>
          </tr>
          <tr>
            <td style={{ width: '25%' }} className="legal-company-table-header">
              Billing Address Street:
            </td>
            <td colSpan={5}>
              {billingAddress ? billingAddress.address1 + ' ' + billingAddress.address2 : ''}
            </td>
          </tr>
          <tr>
            <td style={{ width: '25%' }} className="legal-company-table-header">
              City:
            </td>
            <td>{billingAddress ? billingAddress.city : ''}</td>
            <td style={{ width: '10%' }} className="legal-company-table-header">
              State:
            </td>
            <td style={{ width: '10%' }}>{billingAddress ? billingAddress.state : ''}</td>
            <td style={{ width: '15%' }} className="legal-company-table-header">
              Zip:
            </td>
            <td>{billingAddress ? billingAddress.zip : ''}</td>
          </tr>
        </Table>

        {/* <h5 className="loa-doc-subtitle">Exhibit A: Locations and Phone Numbers</h5>
        <div className="proposalDetails" style={{ marginBottom: '25px' }}>
          {locations &&
            locations.map((location, i) => (
              <div className="no-break">
                <div className="locationRow no-break">
                  <span className="locationRowName">{location.name || ''}</span>
                </div>
                {location.proposalBoxes.map(box => {
                  return (
                    <Table
                      className="tableSecondary text-md-left table-mb-not no-break service-total-table"
                      bordered
                      size="sm"
                    >
                      <thead>
                        <tr className="boxName boxNameView">
                          <th
                            colSpan={4}
                            style={{
                              textAlign: 'center',
                              color: '#212529',
                              border: '1px solid black',
                            }}
                          >
                            {box.boxName || box.defaultBoxName}
                          </th>
                        </tr>

                        <tr className="epikDescriptionRow">
                          <td style={{ width: '65%' }}>EPIK Services Description</td>
                          <td style={{ width: '12.5%' }}>Unit Price</td>
                          <td style={{ width: '10%' }}>Quantity</td>
                          <td style={{ width: '12.5%' }}>Net Price</td>
                        </tr>
                      </thead>
                      <tbody>
                        <ProposalBoxView
                          key={box.boxId}
                          box={box}
                          boxTotal={getBoxSumAmount(box, proposalData.priceKey)}
                          priceKey={proposalData.priceKey && proposalData.priceKey.value}
                          productGroups={proposalData ? proposalData.productGroups : {}}
                        />
                      </tbody>
                    </Table>
                  );
                })}
                <div className="emptyTr mrc-row-loc">
                  <span style={{ textAlign: 'right' }} className="mrc-row-name">
                    MRC {location.name || ''}:
                  </span>
                  <span style={{ textAlign: 'right' }} className="viewRowRedColor">
                    ${getLocationSumAmount(location.proposalBoxes, proposalData.priceKey)}
                  </span>
                </div>
              </div>
            ))}
        </div> */}

        <h3 className="loa-doc-subtitle">Customer Addresses Covered by this LOA Agreement:</h3>
        <Table bordered className="customer-addresses-table">
          <tr className="gray-table-header no-break">
            <td>Location</td>
            <td>Address</td>
            <td>Site Contact</td>
            <td>Email</td>
            <td>Office #</td>
            <td>Mobile #</td>
            <td>Fax #</td>
          </tr>
          {locations && locations.length ? (
            locations.map(loc => (
              <tr className="no-break">
                <td>{loc.name || ''}</td>
                <td>{loc.serviceAdress || ''}</td>
                <td />
                <td />
                <td />
                <td />
                <td />
              </tr>
            ))
          ) : (
            <tr className="no-break">
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
            </tr>
          )}
        </Table>
        <div className="no-break">
          <h3 className="loa-doc-subtitle">Designated Action on Existing Phone Numbers:</h3>
          <Table bordered className="design-action-table">
            <caption className="caption-left">
              Please attach additional forms for more numbers
            </caption>
            <thead>
              <tr className="gray-table-header">
                <th style={{ width: '25%' }}>Location</th>
                <th>Action(Port or New)</th>
                <th>Telephone Number (xxx) xxx-xxxx</th>
                <th>If a Range, Ending Telephone Number</th>
                <th>Current Line Type/Use (fax, fire, alarm, etc.)</th>
                <th>Current Carrier</th>
              </tr>
            </thead>
            {[...Array(5)].map((_, i) => (
              <tr key={i}>
                <td />
                <td />
                <td />
                <td />
                <td />
                <td />
              </tr>
            ))}
          </Table>
        </div>

        {/* hidden */}
        <div hidden className="no-break">
          <h3 className="loa-doc-subtitle">
            Designated Action on Existing Toll-Free Phone Numbers:
          </h3>
          <Table bordered className="design-action-table">
            <caption className="caption-left">See Exhibit B for complete list of numbers</caption>
            <thead>
              <tr className="gray-table-header">
                <th style={{ width: '25%' }}>Location</th>
                <th>Action(Port or New)</th>
                <th>Telephone Number (xxx) xxx-xxxx</th>
                <th>If a Range, Ending Telephone Number</th>
                <th>Current Line Type/Use (fax, fire, alarm, etc.)</th>
                <th>Current Carrier</th>
              </tr>
            </thead>
            {[...Array(5)].map((_, i) => (
              <tr key={i}>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            ))}
          </Table>
        </div>

        <p className="loa-doc-page-notes no-break">
          <b>NOTE:</b> PLEASE DO NOT PLACE ANY NEW SERVICE ORDERS WITH YOUR CURRENT SERVICE
          PROVIDER(s) ON THIS ACCOUNT, WHICH WILL CAUSE A DELAY IN PORTING YOUR NUMBERS.
        </p>
        <p className="loa-doc-page-under">
          Signatures transmitted and delivered via facsimile, scanned and electronically delivered
          or signed electronically and electronically delivered, shall be treated for all purposes
          of the LOA as original signatures and shall be deemed valid, binding and enforceable.
        </p>
        <p>
          Thank you for choosing EPIK as your service provider. You may continue to use your
          existing telephone number with EPIK service. In order to transition your current telephone
          number to EPIK, EPIK must work with your previous service providers to ensure that your
          service is uninterrupted, and where necessary, to ensure that your number(s) are
          transferred.
          <br />
          Your current service providers may require this letter as a proof that you have explicitly
          authorized and requested that your service and current telephone number be transferred to
          EPIK. By filling in all the information requested, and signing and dating this agreement,
          you provide EPIK with the authorization to initiate the process of transferring your
          service and telephone number to EPIK Services. You will then be able to use your old
          numbers with your EPIK service.
        </p>
      </div>
    </div>
  );
};

export default LoaSection;
